export default "__VITE_ASSET__11c30672__"